<template>
  <div class="unit-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Configurações &raquo; Informações d{{ letter }} {{ termSingular }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="unitForm.id != null">
          <b-col>
            <div class="alert text-left" :class="unitForm.is_current_default ? 'alert-warning' : 'alert-secondary'" role="alert">
              <p v-if="unitForm.is_current_default" class="mb-0"><i class="far fa-home mr-2"></i>Unidade principal da conta</p>
              <div v-else class="d-flex align-items-center justify-content-between">
                Habilitar como unidade principal da conta
                <div class="pretty p-switch p-fill ml-2 mr-0">
                  <input type="checkbox" v-model="unitForm.is_default"/>
                  <div class="state p-success">
                    <label><span></span></label>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <validation-observer ref="unitForm" v-slot="{ invalid }">
          <b-row>
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Dados da Unidade</p>
                  </div>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col cols="12">
                      <label class="cj-label mb-2">Os campos a seguir são exibidos para os pacientes nas mensagens de lembretes, agenda on-line e documentos dos pacientes que esta Unidade estiver associada.</label>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Nome Fantasia / Nome completo</label>
                      <validation-provider name="nome fantasia / nome completo" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="unitForm.display_name" :class="{ 'error': errors.length > 0 }"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CPF / CNPJ</label>
                      <validation-provider name="CPF / CNPJ" :rules="{ required: true, cpfOrCnpj: true }" v-slot="{ errors }">
                        <b-form-input type="tel" v-model="unitForm.display_document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##', '##.###.###/####-##']"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Telefone comercial</label>
                      <validation-provider name="telefone comercial" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="tel" v-model="unitForm.display_telephone" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Celular / Whatsapp comercial</label>
                      <b-form-input type="text" v-model="unitForm.display_cellphone" v-mask="'(##) #####-####'"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">E-mail comercial</label>
                      <validation-provider name="e-mail comercial" :rules="{ required: true, email: true }" v-slot="{ errors }">
                        <b-form-input type="email" v-model="unitForm.display_email" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col></b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col cols="12">
                      <hr>
                      <p>Endereço</p>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CEP</label>
                      <validation-provider name="cep" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="tel" v-model="unitForm.display_address.zip_code" v-mask="'#####-###'" :class="{ 'error': errors.length > 0 }" v-on:blur="findCep(unitForm.display_address.zip_code)" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="8">
                      <label class="cj-label">Endereço</label>
                      <validation-provider name="endereço" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="unitForm.display_address.address" ref="display_address" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Número</label>
                      <validation-provider name="número" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="tel" v-model="unitForm.display_address.number" ref="display_number" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Complemento</label>
                      <b-form-input type="text" v-model="unitForm.display_address.complement" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Bairro</label>
                      <validation-provider name="bairro" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="unitForm.display_address.neighborhood" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Cidade</label>
                      <validation-provider name="cidade" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="unitForm.display_address.city" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Estado</label>
                      <validation-provider name="estado" :rules="{ required: true, length: 2 }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="unitForm.display_address.state" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(unitForm.id == null && canAdd) || (unitForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveUnit" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Dados Fiscais e Meio de Pagamento Integrado</p>
                    <div class="pretty p-switch p-fill" v-if="unitForm.zoop_seller_id == null && !unitForm.is_current_tax_info_enabled">
                      <input type="checkbox" v-model="unitForm.tax_info_enabled" />
                      <div class="state p-success">
                        <label></label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="content" v-if="unitForm.tax_info_enabled">
                  <b-row class="mb-2">
                    <b-col cols="12">
                      <label class="cj-label mb-2">Os campos a seguir serão utilizado para emissão de nota fiscal e habilitar o recebimento pelos meios de pagamento integrados.</label>
                    </b-col>
                    <b-col cols="12" md="4">
                      <label class="cj-label">Tipo (não poderá ser alterado)</label>
                      <validation-provider name="tipo" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="unitForm.type" :options="sellerTypeOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo" :disabled="unitForm.is_current_tax_info_enabled && unitForm.type != null" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <template v-if="unitForm.type != null">
                    <b-row>
                      <b-col cols="12">
                        <hr>
                        <p>Informações Fiscais</p>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="unitForm.type.value == 'pj'">
                      <b-col>
                        <label class="cj-label">Razão social</label>
                        <validation-provider name="razão social" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="unitForm.company_name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Nome fantasia</label>
                        <b-form-input type="text" v-model="unitForm.company_fantasy_name" autocomplete="off"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">CNPJ (não poderá ser alterado)</label>
                        <validation-provider name="CNPJ" :rules="{ required: true, cnpj: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="unitForm.company_document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['##.###.###/####-##']" :disabled="unitForm.is_current_tax_info_enabled && unitForm.company_document != null && unitForm.company_document.length > 0"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2" v-else>
                      <b-col>
                        <label class="cj-label">Nome completo</label>
                        <validation-provider name="nome completo" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="unitForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">CPF (não poderá ser alterado)</label>
                        <validation-provider name="CPF" :rules="{ required: true, cpf: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="unitForm.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##']" :disabled="unitForm.is_current_tax_info_enabled && unitForm.document != null && unitForm.document.length > 0"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Data de nascimento</label>
                        <validation-provider name="data de nascimento" :rules="{ required: true }" v-slot="{ errors }">
                          <date-picker name="birthday" v-model="unitForm.birthday" :class="{ 'error': errors.length > 0 }" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off"></date-picker>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">E-mail (será o usuário de acesso na plataforma de pagamento e não poderá ser alterado futuramente)</label>
                        <validation-provider name="e-mail" :rules="{ required: true, email: true }" v-slot="{ errors }">
                          <b-form-input type="email" v-model="unitForm.email" :class="{ 'error': errors.length > 0 }" autocomplete="off" :disabled="unitForm.zoop_seller_id != null"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Telefone</label>
                        <validation-provider name="telefone" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="unitForm.telephone" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Celular / Whatsapp</label>
                        <b-form-input type="text" v-model="unitForm.cellphone" v-mask="'(##) #####-####'"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <hr>
                        <p>Endereço</p>
                      </b-col>
                      <b-col>
                        <label class="cj-label">CEP</label>
                        <validation-provider name="cep (endereço fiscal)" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="unitForm.address.zip_code" v-mask="'#####-###'" :class="{ 'error': errors.length > 0 }" v-on:blur="findCep(unitForm.address.zip_code)" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="8">
                        <label class="cj-label">Endereço</label>
                        <validation-provider name="endereço (endereço fiscal)" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="unitForm.address.address" ref="address" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Número</label>
                        <validation-provider name="número (endereço fiscal)" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="unitForm.address.number" ref="number" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Complemento</label>
                        <b-form-input type="text" v-model="unitForm.address.complement" autocomplete="off"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Bairro</label>
                        <validation-provider name="bairro (endereço fiscal)" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="unitForm.address.neighborhood" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Cidade</label>
                        <validation-provider name="cidade (endereço fiscal)" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="unitForm.address.city" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Estado</label>
                        <validation-provider name="estado (endereço fiscal)" :rules="{ required: true, length: 2 }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="unitForm.address.state" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="unitForm.type.value == 'pj'">
                      <b-col cols="12" class="mt-2">
                        <hr>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Código coligada (opcional)</label>
                        <b-form-input type="text" v-model="unitForm.affiliation_code" autocomplete="off"></b-form-input>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Código filial (opcional)</label>
                        <b-form-input type="text" v-model="unitForm.branch_code" autocomplete="off"></b-form-input>
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="unitForm.type.value == 'pj'">
                      <b-col cols="12">
                        <hr>
                        <p>Responsável financeiro</p>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Nome</label>
                        <validation-provider name="nome do responsável financeiro" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="unitForm.financial_responsible_name" :class="{ 'error': errors.length > 0 }"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">CPF</label>
                        <validation-provider name="CPF do responsável financeiro" :rules="{ required: true, cpfOrCnpj: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="unitForm.financial_responsible_document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##', '##.###.###/####-##']"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Telefone</label>
                        <validation-provider name="telefone do responsável financeiro" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input type="tel" v-model="unitForm.financial_responsible_telephone" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">E-mail</label>
                        <validation-provider name="e-mail do responsável financeiro" :rules="{ required: true, email: true }" v-slot="{ errors }">
                          <b-form-input type="email" v-model="unitForm.financial_responsible_email" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col></b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12" class="mt-2">
                        <hr>
                      </b-col>
                      <b-col cols="12" class="mb-2">
                        <table class="table table-responsive table-bordered m-0" style="display: table;">
                          <tbody>
                          <tr>
                            <td>Habilitar Meio de Pagamento Integrado</td>
                            <td class="text-center">
                              <div class="pretty p-switch p-fill">
                                <input type="checkbox" v-model="unitForm.charging_enabled" :disabled="unitForm.zoop_seller_id != null" />
                                <div class="state p-success">
                                  <label></label>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <label class="cj-label">Ao habilitar o meio de pagamento integrado, seus dados serão enviados para a operadora de pagamentos e os dados acima, sinalizados com um cadeado, não poderão ser modificados posteriormente. Os dados também devem corresponder com os dados dos documentos comprovantes que são obrigatórios para o credenciamento.</label>
                      </b-col>
                    </b-row>
                    <template v-if="unitForm.charging_enabled">
                      <b-row class="mb-2">
                        <b-col cols="12" md="6">
                          <label class="cj-label">Categoria do negócio (não poderá ser alterado)</label>
                          <validation-provider name="categoria do negócio" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="unitForm.category" :options="sellerCategoryOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="true" placeholder="Selecione uma categoria" :disabled="unitForm.zoop_seller_id != null" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">{{unitForm.type.value == 'pj' ? 'Faturamento' : 'Renda'}}</label>
                          <validation-provider :name="unitForm.type.value == 'pj' ? 'faturamento' : 'renda'" :rules="{ required: true }" v-slot="{ errors }">
                            <money v-model="unitForm.income" class="form-control mb-2" :class="{ 'error': errors.length > 0 }"></money>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col v-if="unitForm.type.value == 'pj'">
                          <label class="cj-label">Data de abertura</label>
                          <validation-provider name="data de abertura" :rules="{ required: true }" v-slot="{ errors }">
                            <date-picker name="company_opening_date" v-model="unitForm.company_opening_date" :class="{ 'error': errors.length > 0 }" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off"></date-picker>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col v-else></b-col>
                      </b-row>
                      <template v-if="unitForm.type.value == 'pj'">
                        <b-row class="mb-2">
                          <b-col cols="12">
                            <hr>
                            <p>Dados do Proprietário</p>
                          </b-col>
                          <b-col>
                            <label class="cj-label">Nome completo</label>
                            <validation-provider name="nome completo" :rules="{ required: true }" v-slot="{ errors }">
                              <b-form-input type="text" v-model="unitForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label class="cj-label">CPF</label>
                            <validation-provider name="CPF" :rules="{ required: true, cpf: true }" v-slot="{ errors }">
                              <b-form-input type="tel" v-model="unitForm.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##']"></b-form-input>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                          <b-col>
                            <label class="cj-label">Data de nascimento</label>
                            <validation-provider name="data de nascimento" :rules="{ required: true }" v-slot="{ errors }">
                              <date-picker name="birthday" v-model="unitForm.birthday" :class="{ 'error': errors.length > 0 }" v-mask="'##/##/####'" :config="datePickerOptions" autocomplete="off"></date-picker>
                              <span class="cj-error">{{ errors[0] }}</span>
                            </validation-provider>
                          </b-col>
                        </b-row>
                      </template>
                      <b-row class="mb-2">
                        <b-col cols="12">
                          <hr>
                          <p class="mb-2">Vendas no cartão de crédito</p>
                        </b-col>
                        <b-col cols="12" md="4" lg="3">
                          <label class="cj-label">Número máximo de parcelas</label>
                          <validation-provider name="número máximo de parcelas" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="unitForm.zoop_max_installments" :options="installmentOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" placeholder="Número máximo de parcelas" @select="maxInstallmentsSelected" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col cols="12" md="4" lg="3">
                          <label class="cj-label">Repassar juros de parcelamento para clientes?</label>
                          <validation-provider name="repassar juros de parcelamento para clientes" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="unitForm.zoop_max_installments_without_fees" :options="installmentWithoutFeesOptions" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="false" :searchable="true" placeholder="Repassar juros de parcelamento para clientes" :class="{ 'error': errors.length > 0 }"></multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="12">
                          <hr>
                          <p class="mb-0">Conta bancária para recebimento</p>
                          <label class="cj-label mb-2">Você só pode cadastrar contas bancárias do mesmo titular do CNPJ/CPF</label>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Titular</label>
                          <b-form-input type="text" :value="unitForm.company_name != null ? unitForm.company_name : unitForm.name" disabled></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Banco</label>
                          <validation-provider name="banco" :rules="{ required: true }" v-slot="{ errors }">
                            <multiselect v-model="unitForm.bankAccount.bank" :options="bankOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="true" :searchable="true" placeholder="Selecione um banco" :class="{ 'error': errors.length > 0 }">
                              <template slot="clear">
                                <div class="multiselect__clear" v-if="unitForm.bankAccount.bank != null" @mousedown.prevent.stop="unitForm.bankAccount.bank = null"></div>
                              </template>
                            </multiselect>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Tipo de conta</label>
                          <multiselect v-model="unitForm.bankAccount.type" :options="bankTypeOptions" track-by="name" label="name" :showLabels="false" :allowEmpty="false" :searchable="false" placeholder="Selecione um tipo de conta"></multiselect>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Agência (sem DV)</label>
                          <validation-provider name="agência" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="unitForm.bankAccount.agency" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="'###########'"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Conta (com DV)</label>
                          <validation-provider name="conta" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="unitForm.bankAccount.account" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="'###############'"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>

<!--                        <b-col cols="12" class="mt-2">-->
<!--                          <hr>-->
<!--                          <p class="mb-0">Documentos</p>-->
<!--                          <label class="cj-label mb-2">Os documentos devem coincidir com os dados informados no campos acima, qualquer divergência pode resultar no não credenciamento junto a operadora dos meios de pagamento</label>-->
<!--                        </b-col>-->
<!--                        <b-col cols="12" md="6" v-if="unitForm.type.value == 'pj'">-->
<!--                          <b-row>-->
<!--                            <b-col cols="12">-->
<!--                              <p class="mb-1">Cartão CNPJ/Contrato social</p>-->
<!--                            </b-col>-->
<!--                            <b-col cols="12" class="mb-3">-->
<!--                              <label class="cj-label">Cópia do cartão do CNPJ ou cópia do contrato social da empresa</label>-->
<!--                              <validation-provider v-if="!unitForm.documents.cnpj.uploaded" name="cartão CNPJ/contrato social" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                <b-form-file v-model="unitForm.documents.cnpj.selected_file" @input="attachmentChanged('cnpj')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>-->
<!--                                <span class="cj-error">{{ errors[0] }}</span>-->
<!--                              </validation-provider>-->
<!--                              <span v-else class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>-->
<!--                            </b-col>-->
<!--                          </b-row>-->
<!--                        </b-col>-->
<!--                        <b-col cols="12" md="6">-->
<!--                          <b-row>-->
<!--                            <b-col cols="12">-->
<!--                              <p class="mb-1">Comprovante de atividade</p>-->
<!--                            </b-col>-->
<!--                            <b-col cols="12" class="mb-3">-->
<!--                              <label class="cj-label">Comprovante da atividade exercida (cartão de visita, print do site, nota fiscal de compra de produtos ou prestação de serviços, etc)</label>-->
<!--                              <validation-provider v-if="!unitForm.documents.atividade.uploaded" name="comprovante da atividade exercida" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                <b-form-file v-model="unitForm.documents.atividade.selected_file" @input="attachmentChanged('atividade')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>-->
<!--                                <span class="cj-error">{{ errors[0] }}</span>-->
<!--                              </validation-provider>-->
<!--                              <span v-else class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>-->
<!--                            </b-col>-->
<!--                          </b-row>-->
<!--                        </b-col>-->
<!--                        <b-col cols="12" md="6">-->
<!--                          <b-row>-->
<!--                            <b-col cols="12">-->
<!--                              <p class="mb-1">Documento de identidade</p>-->
<!--                            </b-col>-->
<!--                            <b-col cols="12" class="mb-3">-->
<!--                              <label class="cj-label">Documento de identidade com foto (RG e CPF ou CNH){{ unitForm.type.value == 'pj' ? ' do proprietário/sócios' : '' }}</label>-->
<!--                              <validation-provider v-if="!unitForm.documents.identificacao.uploaded" name="documento de identidade" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                <b-form-file v-model="unitForm.documents.identificacao.selected_file" @input="attachmentChanged('identificacao')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>-->
<!--                                <span class="cj-error">{{ errors[0] }}</span>-->
<!--                              </validation-provider>-->
<!--                              <span v-else class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>-->
<!--                            </b-col>-->
<!--                          </b-row>-->
<!--                        </b-col>-->
<!--                        <b-col cols="12" md="6">-->
<!--                          <b-row>-->
<!--                            <b-col cols="12">-->
<!--                              <p class="mb-1">Comprovante de residência</p>-->
<!--                            </b-col>-->
<!--                            <b-col cols="12" class="mb-3">-->
<!--                              <label class="cj-label">Comprovante de residência em {{ unitForm.type.value == 'pj' ? 'nome do proprietário/sócios' : 'seu nome (ou de familiares)' }}</label>-->
<!--                              <validation-provider v-if="!unitForm.documents.residencia.uploaded" name="comprovante de residência" :rules="{ required: true }" v-slot="{ errors }">-->
<!--                                <b-form-file v-model="unitForm.documents.residencia.selected_file" @input="attachmentChanged('residencia')" placeholder="" accept="image/png,image/jpeg,application/pdf"></b-form-file>-->
<!--                                <span class="cj-error">{{ errors[0] }}</span>-->
<!--                              </validation-provider>-->
<!--                              <span v-else class="d-block document-sent mb-2"><i class="fa fa-check text-success mr-1"></i>Enviado</span>-->
<!--                            </b-col>-->
<!--                          </b-row>-->
<!--                        </b-col>-->
                      </b-row>
                    </template>
                  </template>
                </div>
                <div class="footer" v-if="unitForm.tax_info_enabled && ((unitForm.id == null && canAdd) || (unitForm.id != null && canEdit))">
                  <b-button variant="primary" class="mr-3" @click="saveUnit" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
            <b-col v-if="unitForm.zoop_seller_id != null" cols="12">
              <div class="alert text-center" :class="getStatus(unitForm).class" role="alert">
                <p class="mb-0">{{ getStatus(unitForm).name }}</p>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  Políticas de cancelamento, reagendamento e não comparecimento
                </div>
                <div class="content">
                  <b-row>
                    <b-col>
                      <label class="cj-label">Descrição</label>
                      <b-textarea rows="5" v-model="unitForm.policies"></b-textarea>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(unitForm.id == null && canAdd) || (unitForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveUnit">Salvar</b-button>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  Termos e aceites
                </div>
                <div class="content">
                  <b-row>
                    <b-col>
                      <label class="cj-label">Descrição</label>
                      <ckeditor :editor="editor" v-model="unitForm.terms_and_acceptances" :config="editorConfig"></ckeditor>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(unitForm.id == null && canAdd) || (unitForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="saveUnit">Salvar</b-button>
                </div>
              </div>
            </b-col>

            <b-col cols="12" v-if="unitForm.id != null && !unitForm.is_current_default && canRemove">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Remover {{ termSingular }}</p>
                </div>
                <div class="content">
                  <validation-observer ref="removeForm" v-slot="{ invalid }">
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Informe o nome fantasia / nome completo d{{ letter }} {{ termSingular }}</label>
                        <validation-provider :name="'nome fantasia / nome completo d'+letter+' '+termSingular" v-slot="{ errors }">
                          <b-form-input type="text" v-model="deleteForm.verification" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </validation-observer>
                </div>
                <div class="footer">
                  <b-button variant="danger" class="mr-3" @click="deleteUnit" block :disabled="(unitForm.display_name != deleteForm.verification)">Remover {{ termSingular }}</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>

  </div>
</template>

<script>
  import axios from 'axios'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br';

  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'unidade',
        termPlural: 'unidades',
        url: 'unidades',
        letter: 'a',
        newTerm: 'cadastrar-unidade',
        module: 'units',
        user: null,

        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        sellerTypeOptions: [
          {value: 'pf', name: 'Pessoa física'},
          {value: 'pj', name: 'Pessoa jurídica'}
        ],
        bankOptions: [],
        bankTypeOptions: [
          {value: '0', name: 'Conta corrente'},
          {value: '1', name: 'Poupança'}
        ],
        sellerCategoryOptions: [],

        editor: ClassicEditor,
        editorConfig: {
          language: 'pt-br',
          toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'blockQuote', 'insertTable', 'undo', 'redo' ]
        },

        unitForm: {
          id: null,
          status: 'INCOMPLETE',
          zoop_seller_id: null,
          is_current_default: false,
          is_current_tax_info_enabled: false,
          // is_default: {value: false, name: 'Não'},
          is_default: false,
          display_name: null,
          display_document: null,
          display_telephone: null,
          display_cellphone: null,
          display_email: null,
          tax_info_enabled: false,

          category: null,
          type: null,
          company_document: null,
          company_name: null,
          company_fantasy_name: null,
          company_opening_date: null,
          income: 0,
          name: null,
          document: null,
          email: null,
          birthday: null,
          telephone: null,
          cellphone: null,
          // documents: {
          //   cnpj: {file: null, file_name: null, selected_file: null, uploaded: false},
          //   atividade: {file: null, file_name: null, selected_file: null, uploaded: false},
          //   identificacao: {file: null, file_name: null, selected_file: null, uploaded: false},
          //   residencia: {file: null, file_name: null, selected_file: null, uploaded: false},
          // },
          display_address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          },
          address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          },
          affiliation_code: null,
          branch_code: null,
          financial_responsible_name: null,
          financial_responsible_document: null,
          financial_responsible_telephone: null,
          financial_responsible_email: null,
          policies: null,
          terms_and_acceptances: null,
          bankAccount: {
            bank: null,
            type: {value: '0', name: 'Conta corrente'},
            agency: null,
            account: null,
          },
          charging_enabled: false,
          zoop_max_installments: { value: '1', name: '1x' },
          zoop_max_installments_without_fees: null
        },

        installmentOptions: [
          { value: '1', name: '1x' },
          { value: '2', name: '2x' },
          { value: '3', name: '3x' },
          { value: '4', name: '4x' },
          { value: '5', name: '5x' },
          { value: '6', name: '6x' },
          { value: '7', name: '7x' },
          { value: '8', name: '8x' },
          { value: '9', name: '9x' },
          { value: '10', name: '10x' },
          { value: '11', name: '11x' },
          { value: '12', name: '12x' }
        ],

        installmentWithoutFeesOptions: [],

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },


        deleteForm: {
          verification: ''
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        }
      }
    },
    async mounted () {
      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.user = JSON.parse(localStorage.getItem('user'));

      this.canAdd = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_edit');
      // this.canRemove = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canRemove = this.helpers.isOwner()?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_manage');

      await this.api.getUnitConfigData().then(res => {
        if(this.leavingPage) {
          return;
        }
        this.bankOptions = [];
        this.sellerCategoryOptions = [];
        res.data.banks.forEach(bank => {
          this.bankOptions.push({ value: bank.id, name: bank.name });
        });
        res.data.categories.forEach(category => {
          this.sellerCategoryOptions.push({ value: category.id, name: category.name });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Unit Config Data', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as categorias! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Unit Config Data', err.response);
      });


      if(this.$route.params.id != this.newTerm) {
        await this.api.getUnit(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let unitData = res.data;

          let displayAddress = (unitData.display_address == null) ? {
            id: null,
            zip_code: '',
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          } : unitData.display_address;

          let address = (unitData.address == null) ? {
            id: null,
            zip_code: '',
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          } : unitData.address;
          let bankAccount = (unitData.latest_bank_account == null) ? {
            bank: null,
            type: {value: '0', name: 'Conta corrente'},
            agency: null,
            account: null,
          } : unitData.latest_bank_account;

          if(unitData.latest_bank_account != null) {
            bankAccount.bank = this.bankOptions.find(g => g.value == unitData.latest_bank_account.bank_id);
            bankAccount.type = this.bankTypeOptions.find(g => g.value == unitData.latest_bank_account.is_savings ? 1 : 0);
          }
          this.installmentWithoutFeesOptions = [{value:null, name: 'Não repassar'}];
          for(let index = 1; index < unitData.zoop_max_installments; index++) {
            this.installmentWithoutFeesOptions.push({value:index, name: 'A partir de parcelamentos em ' + (index + 1) + 'x'});
          }

          this.unitForm = {
            id: unitData.id,
            status: unitData.status,
            zoop_seller_id: unitData.zoop_seller_id,
            is_current_default: unitData.is_default,
            // is_default: this.defaultOptions.find(g => g.value == unitData.is_default),
            display_name: unitData.display_name,
            display_document: unitData.display_document,
            display_telephone: unitData.display_telephone,
            display_cellphone: unitData.display_cellphone,
            display_email: unitData.display_email,
            tax_info_enabled: unitData.tax_info_enabled,
            is_current_tax_info_enabled: unitData.tax_info_enabled,

            type: unitData.company_document != null || unitData.document != null ? this.sellerTypeOptions.find(g => g.value == (unitData.company_document == null ? 'pf' : 'pj')) : null,
            category: unitData.zoop_seller_category != null ? this.sellerCategoryOptions.find(g => g.value == unitData.zoop_seller_category) : null,
            company_name: unitData.company_name,
            company_fantasy_name: unitData.company_fantasy_name,
            company_document: unitData.company_document,
            company_opening_date: unitData.company_opening_date != null && this.moment(unitData.company_opening_date).isValid()?this.moment(unitData.company_opening_date).format('DD/MM/YYYY'):'',
            income: unitData.income,
            name: unitData.name,
            document: unitData.document,
            email: unitData.email,
            telephone: unitData.telephone,
            cellphone: unitData.cellphone,
            birthday: unitData.birthday != null && this.moment(unitData.birthday).isValid()?this.moment(unitData.birthday).format('DD/MM/YYYY'):'',
            // documents: {
            //   cnpj: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_company_document_id != null},
            //   atividade: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_activity_document_id != null},
            //   identificacao: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_id_document_id != null},
            //   residencia: {file: null, file_name: null, selected_file: null, uploaded: unitData.zoop_seller_residence_document_id != null},
            // },
            display_address: displayAddress,
            address: address,
            affiliation_code: unitData.affiliation_code,
            branch_code: unitData.branch_code,
            financial_responsible_name: unitData.financial_responsible_name,
            financial_responsible_document: unitData.financial_responsible_document,
            financial_responsible_telephone: unitData.financial_responsible_telephone,
            financial_responsible_email: unitData.financial_responsible_email,
            policies: unitData.policies,
            terms_and_acceptances: unitData.terms_and_acceptances,
            bankAccount: bankAccount,
            charging_enabled: unitData.zoop_seller_id != null || unitData.status != 'INCOMPLETE',
            zoop_max_installments: this.installmentOptions.find(d => d.value == unitData.zoop_max_installments),
            zoop_max_installments_without_fees: this.installmentWithoutFeesOptions.find(d => d.value == unitData.zoop_max_installments_without_fees),
          };


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Unit', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/configuracoes/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar este ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Unit', err.response);
        });
      } else {
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);
    },
    watch: {
      'unitForm.tax_info_enabled': {
        handler(newValue) {
          if(newValue) {
            if(this.unitForm.type == null) {
              if(this.unitForm.display_document != null) {
                let isCompany = this.unitForm.display_document != null && this.unitForm.display_document.length == 18;
                this.unitForm.type = this.sellerTypeOptions.find(g => g.value == (isCompany ? 'pj' : 'pf'));
                if(isCompany) {
                  this.unitForm.company_document = this.unitForm.display_document;
                  this.unitForm.company_name = this.unitForm.display_name;
                }
                else {
                  this.unitForm.document = this.unitForm.display_document;
                  this.unitForm.name = this.unitForm.display_name;
                }
              }
              this.unitForm.email = this.unitForm.display_email;
              this.unitForm.telephone = this.unitForm.display_telephone;
              this.unitForm.cellphone = this.unitForm.display_cellphone;
              this.unitForm.address = this.unitForm.display_address;
              this.unitForm.address = JSON.parse(JSON.stringify(this.unitForm.display_address));
              this.unitForm.address.id = null;
            }
          }
        }
      },
    },
    methods: {
      async saveUnit() {
        if(!this.canPerformAction || (this.unitForm.id == null && !this.canAdd) || (this.unitForm.id != null && !this.canEdit)) {
          return false;
        }

        const isValid = await this.$refs.unitForm.validate();
        if(!isValid) {
          return false;
        }
        // Só é possível ter uma unidade definida como principal. Ao tornar esta a principal, a outra unidade deixará automaticamente de ser.
        if(!this.unitForm.is_current_default && this.unitForm.is_default) {
          this.$swal({
            title: 'Atenção',
            text: 'Esta unidade se tornará a unidade principal da conta e seus dados serão utilizados em todas as situações em que não for especificada uma unidade.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if (res.value) {
              this.saveUnitRequest();
            }
          });
        }
        else {
          await this.saveUnitRequest();
        }
      },

      async saveUnitRequest() {
        this.canPerformAction = false;

        this.eventBus.$emit('IS_LOADING', true);

        let isCompany = this.unitForm.type != null && this.unitForm.type.value == 'pj';
        let unitData =  {
          id: this.unitForm.id,
          // is_default: this.unitForm.is_default.value,
          is_default: this.unitForm.is_default,
          display_name: this.unitForm.display_name,
          display_document: this.unitForm.display_document,
          display_telephone: this.unitForm.display_telephone,
          display_cellphone: this.unitForm.display_cellphone,
          display_email: this.unitForm.display_email,
          tax_info_enabled: this.unitForm.tax_info_enabled,

          zoop_seller_category: this.unitForm.category != null ? this.unitForm.category.value : null,
          company_name: isCompany ? this.unitForm.company_name : null,
          company_fantasy_name: isCompany ? this.unitForm.company_fantasy_name : null,
          company_document: isCompany ? this.unitForm.company_document : null,
          company_opening_date: isCompany ? this.unitForm.company_opening_date : null,
          name: this.unitForm.name,
          document: this.unitForm.document,
          email: this.unitForm.email,
          income: this.unitForm.income,
          birthday: this.unitForm.birthday,
          telephone: this.unitForm.telephone,
          cellphone: this.unitForm.cellphone,
          display_address: {
            id: this.unitForm.display_address.id,
            zip_code: this.unitForm.display_address.zip_code,
            address: this.unitForm.display_address.address,
            number: this.unitForm.display_address.number,
            complement: this.unitForm.display_address.complement,
            neighborhood: this.unitForm.display_address.neighborhood,
            city: this.unitForm.display_address.city,
            state: this.unitForm.display_address.state,
            country: 'Brazil'
          },
          address: {
            id: this.unitForm.address.id,
            zip_code: this.unitForm.address.zip_code,
            address: this.unitForm.address.address,
            number: this.unitForm.address.number,
            complement: this.unitForm.address.complement,
            neighborhood: this.unitForm.address.neighborhood,
            city: this.unitForm.address.city,
            state: this.unitForm.address.state,
            country: 'Brazil'
          },
          bank_account: {
            bank_id: this.unitForm.bankAccount.bank != null ? this.unitForm.bankAccount.bank.value : null,
            is_savings: this.unitForm.bankAccount.type.value,
            agency: this.unitForm.bankAccount.agency,
            account: this.unitForm.bankAccount.account
          },
          affiliation_code: this.unitForm.affiliation_code,
          branch_code: this.unitForm.branch_code,
          financial_responsible_name: this.unitForm.financial_responsible_name,
          financial_responsible_document: this.unitForm.financial_responsible_document,
          financial_responsible_telephone: this.unitForm.financial_responsible_telephone,
          financial_responsible_email: this.unitForm.financial_responsible_email,
          policies: this.unitForm.policies,
          terms_and_acceptances: this.unitForm.terms_and_acceptances,
          charging_enabled: this.unitForm.charging_enabled,
          zoop_max_installments: this.unitForm.zoop_max_installments ? this.unitForm.zoop_max_installments.value : 1,
          zoop_max_installments_without_fees: this.unitForm.zoop_max_installments_without_fees ? this.unitForm.zoop_max_installments_without_fees.value : null,
          // documents: {}
        };
        // if(this.unitForm.documents.cnpj.file != null) {
        //   unitData.documents.cnpj = this.unitForm.documents.cnpj;
        // }
        // if(this.unitForm.documents.atividade.file != null) {
        //   unitData.documents.atividade = this.unitForm.documents.atividade;
        // }
        // if(this.unitForm.documents.identificacao.file != null) {
        //   unitData.documents.identificacao = this.unitForm.documents.identificacao;
        // }
        // if(this.unitForm.documents.residencia.file != null) {
        //   unitData.documents.residencia = this.unitForm.documents.residencia;
        // }

        if (this.unitForm.id == null) {
          this.api.storeUnit(unitData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if(res.data.is_default) {
              this.user.person.client.default_unit = res.data;
              localStorage.setItem('user', JSON.stringify(this.user));
            }

            if (res.status == 201) {
              this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi cadastrad' + this.letter + ' com sucesso!', 'success').then(() => {
                this.$router.push({path: '/configuracoes/' + this.url}).catch(() => {});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Unit', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            let response = err.response;
            if(response.status == 401) {
              this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                this.$router.push({ path: '/' }).catch(() => {});
              });
            }
            else {
              let message = 'Não conseguimos cadastrar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
              switch (response.status) {
                case 422: message = response.data.errors.join('\r\n'); break;
                case 400: {
                  if(typeof response.data.message != 'undefined' && response.data.message != '') {
                    if(response.data.message.indexOf('duplicate_taxpayer_id:') >= 0) {
                      message = 'Já existe um cadastro com este ' + (isCompany ? 'CNPJ' : 'CPF') + '.';
                    }
                    else if(response.data.message.indexOf('Your "taxpayer_id" value is incorrect') >= 0) {
                      message = 'CPF inválido.';
                    }
                    else if(response.data.message.indexOf('Your "ein" value is incorrect') >= 0) {
                      message = 'CNPJ inválido.';
                    }
                    else {
                      message = response.data.message;
                    }
                  }
                  break;
                }
              }

              this.$swal('Ops...', message, 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Unit', err);
          });
        } else {
          this.api.updateUnit(this.unitForm.id, unitData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if(res.data.is_default) {
              this.user.person.client.default_unit = res.data;
              localStorage.setItem('user', JSON.stringify(this.user));
            }
            if (res.status == 200) {
              this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi atualizado com sucesso!', 'success').then(() => {
                this.$router.push({path: '/configuracoes/' + this.url}).catch(() => {});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Unit', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            let response = err.response;
            if(response.status == 401) {
              this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                this.$router.push({ path: '/' }).catch(() => {});
              });
            }
            else {
              let message = 'Não conseguimos atualizar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
              switch (response.status) {
                case 422: message = response.data.errors.join('\r\n'); break;
                case 400: {
                  if(typeof response.data.message != 'undefined' && response.data.message != '') {
                    if(response.data.message.indexOf('duplicate_taxpayer_id:') >= 0) {
                      message = 'Já existe um cadastro com este ' + (isCompany ? 'CNPJ' : 'CPF') + '.';
                    }
                    else if(response.data.message.indexOf('Your "taxpayer_id" value is incorrect') >= 0) {
                      message = 'CPF inválido.';
                    }
                    else if(response.data.message.indexOf('Your "ein" value is incorrect') >= 0) {
                      message = 'CNPJ inválido.';
                    }
                    else {
                      message = response.data.message;
                    }
                  }
                  break;
                }
              }

              this.$swal('Ops...', message, 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Unit', err);
          });
        }
      },

      maxInstallmentsSelected(selectedOption) {
        if(this.unitForm.zoop_max_installments_without_fees && this.unitForm.zoop_max_installments_without_fees.value > selectedOption.value) {
          this.unitForm.zoop_max_installments_without_fees = null;
        }
        this.installmentWithoutFeesOptions = [{value:null, name: 'Não repassar'}];
        for(let index = 1; index < selectedOption.value; index++) {
          this.installmentWithoutFeesOptions.push({value:index, name: 'A partir de parcelamentos em ' + (index + 1) + 'x'});
        }
      },

      hasFilledBankInput() {
        let fields = this.unitForm.bankAccount;
        return fields.bank != null || !this.isNullOrEmpty(fields.agency) || !this.isNullOrEmpty(fields.account);
      },

      // attachmentChanged(index) {
      //   let attachment = this.unitForm.documents[index];
      //   attachment.file = null;
      //   attachment.file_name = '';
      //   if (attachment.selected_file) {
      //     attachment.file_name = attachment.selected_file.name;
      //     const reader = new FileReader();
      //     reader.onload = (event) => {
      //       attachment.file = event.target.result;
      //     };
      //     reader.readAsDataURL(attachment.selected_file);
      //   }
      // },

      getStatus(unit) {
        if(unit.status == 'INCOMPLETE') {
          // return {name:'O cadastro está incompleto.', class: 'alert-danger'};
          return {name:'O meio de pagamento integrado não foi cadastrado.', class: 'alert-secondary'};
        }
        else if(unit.status == 'pending') {
          return {name:'O meio de pagamento integrado está em análise.', class: 'alert-warning'};
        }
        else if(unit.status == 'enabled' || unit.status == 'active') {
          return {name:'O meio de pagamento integrado está habilitado.', class: 'alert-success'};
        }
        else if(unit.status == 'deleted') {
          return {name:'O meio de pagamento integrado foi excluído.', class: 'alert-danger'};
        }
        else {
          return {name:'O meio de pagamento integrado está desabilitado.', class: 'alert-secondary'};
        }
      },

      isBoxIncomplete(box) {
        let form = this.unitForm;
        if(box == 'general') {
          return form.category == null || (form.type.value == 'pj' && (this.isNullOrEmpty(form.company_document) || this.isNullOrEmpty(form.company_name) || this.isNullOrEmpty(form.company_opening_date))) || this.isNullOrEmpty(form.name) || this.isNullOrEmpty(form.document) || this.isNullOrEmpty(form.birthday) || this.isNullOrEmpty(form.telephone) || this.isNullOrEmpty(form.email) || this.isNullOrEmpty(form.income);
        }
        if(box == 'address') {
          let address = form.address;
          return this.isNullOrEmpty(address.zip_code) || this.isNullOrEmpty(address.address) || this.isNullOrEmpty(address.number) || this.isNullOrEmpty(address.neighborhood) || this.isNullOrEmpty(address.city) || this.isNullOrEmpty(address.state);
        }
        if(box == 'bank_account') {
          let bank = form.bankAccount;
          return bank.bank == null || this.isNullOrEmpty(bank.agency) || this.isNullOrEmpty(bank.account);
        }
        // if(box == 'documents') {
        //   let documents = form.documents;
        //   return (form.type.value == 'pj' && documents.cnpj.file == null && !documents.cnpj.uploaded) || (documents.atividade.file == null && !documents.atividade.uploaded) || (documents.identificacao.file == null && !documents.identificacao.uploaded) || (documents.residencia.file == null && !documents.residencia.uploaded);
        // }
      },

      async deleteUnit() {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação é irreversível!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, remover ' + this.letter + ' ' + this.termSingular + '!',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if (res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);

            let deleteData = {
              verification: this.deleteForm.verification
            };

            this.api.deleteUnit(this.unitForm.id, deleteData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi removido com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/configuracoes/' + this.url}).catch(() => {});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao remover ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Destroy Unit', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos remover ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 400: msg = err.response.data.message; break;
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Destroy Unit', err.response);
            });
          }
        });
      },

      findCep(value) {
        if (value != null && value.length == 9) {
          axios.get('https://viacep.com.br/ws/' + value + '/json/').then(res => {
            if (typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              if(this.unitForm.display_address.zip_code == value) {
                this.unitForm.display_address.address = cepData.logradouro;
                this.unitForm.display_address.neighborhood = cepData.bairro;
                this.unitForm.display_address.city = cepData.localidade;
                this.unitForm.display_address.state = cepData.uf;

                this.$refs.display_number.$el.focus();
              }
              else {
                this.unitForm.address.address = cepData.logradouro;
                this.unitForm.address.neighborhood = cepData.bairro;
                this.unitForm.address.city = cepData.localidade;
                this.unitForm.address.state = cepData.uf;

                this.$refs.number.$el.focus();
              }
            } else {
              if(this.unitForm.display_address.zip_code == value) {
                this.$refs.display_address.$el.focus();
              }
              else {
                this.$refs.address.$el.focus();
              }
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      goBack() {
        this.$router.push({path: '/configuracoes/' + this.url}).catch(() => {});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .unit-form {
    padding: 20px 0;

    .pretty.p-switch .state:before {
      background: #ffffff;
    }


    .box-status {
      font-size: 14px;

      .status-indicator {
        &.complete {
          color: $ufoGreen;
        }
        &.incomplete {
          color: $yellowSea;
        }
      }
    }

    .document-sent {
      font-size: 14px;
    }
  }
</style>
